(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-sticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creative-typography"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaWords !== 'function') {
    class LunaWords extends HTMLElement {
      constructor() {
        super()

        this.init()
        document.addEventListener("shopify:section:load", (event) => {
          this.init();
        });
      }
      init() {
        this.idx = 0
        this.template = this.querySelector('template').content.cloneNode(true)
        const div = document.createElement('div')
        div.className = 'lt-creative_typography-title'
        div.innerHTML = this.processContent(this.template.querySelector('.luna-templates_html').innerHTML);
        div.append(...this.template.querySelector('.luna-templates_blocks').childNodes);

        this.querySelector('.lt-creative_typography-title')?.remove()
        this.append(div)
      }
      processContent(html) {
        return html.replace(/(<[^>]+>.*?<\/[^>]+>)|(\S+)/g, (match, tag) => {
          this.idx += 1
          if(tag) {
            const newtag = tag.replace(/<([a-zA-Z0-9]+)([^>]*?)>(.*?)<\/\1>/g, (_, inner_tag, attrs, content) => content.split(' ').map((word, i) => {
              if(i != 0) this.idx += 1
              const c = `<span class="lt-creative_typography-word" style="order: ${ this.idx }"><${inner_tag}${attrs}>${word}</${inner_tag}></span>`

              return c
            }).join(' '));
            return newtag
          } else {
            return `<span class="lt-creative_typography-word" style="order: ${ this.idx }">${ match }</span>`
          }
        });
      }
    }

    customElements.define('luna-words', LunaWords)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker-sheet"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-canvas')) {
    class StickerCanvas extends HTMLElement {
      constructor() {
        super();
        this.stickers = JSON.parse(this.dataset.stickers || '[]');
        this.currentIndex = 0;
        this.canvas = this.querySelector('.torera-designs-sticker-canvas');
        
        this.init();
      }

      init() {
        if (this.stickers.length === 0) {
          console.warn('No stickers added to section');
          return;
        }

        // Add click event listener to canvas
        this.canvas.addEventListener('click', (e) => this.placeSticker(e));

        // Add clear button functionality
        const clearButton = this.querySelector('.sticker-clear-button');
        if (clearButton) {
          clearButton.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent placing sticker when clicking button
            this.clearAllStickers();
          });
        }
      }

      placeSticker(event) {
        // Check sticker limit (max 50)
        const existingStickers = this.canvas.querySelectorAll('.placed-sticker');
        if (existingStickers.length >= 50) {
          return; // Stop adding more stickers
        }

        // Get current sticker
        const currentSticker = this.stickers[this.currentIndex];

        // Get click position relative to canvas
        const rect = this.canvas.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        // Create sticker element
        const sticker = document.createElement('div');
        sticker.className = 'placed-sticker';
        sticker.style.left = `${x}px`;
        sticker.style.top = `${y}px`;

        // Create image
        const img = document.createElement('img');
        img.src = currentSticker.url;
        img.alt = currentSticker.alt || 'Sticker';
        img.loading = 'lazy';

        sticker.appendChild(img);
        this.canvas.appendChild(sticker);

        // Cycle to next sticker
        this.currentIndex = (this.currentIndex + 1) % this.stickers.length;
      }

      clearAllStickers() {
        // Remove all placed stickers
        const allStickers = this.canvas.querySelectorAll('.placed-sticker');
        allStickers.forEach(sticker => sticker.remove());
        
        // Reset index to start from first sticker again
        this.currentIndex = 0;
      }
    }
    
    customElements.define('sticker-canvas', StickerCanvas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-stickers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-sticker-animated')) {
    class TDStickerAnimated extends HTMLElement {
      constructor() {
        super();
        this.animationSpeed = 0.2;
        this.init();
      }

      init() {
        const stickers = document.querySelectorAll('.td-animated-sticker');
        
        stickers.forEach(sticker => {
          const animation = sticker.getAttribute('data-animation');
          const speed = parseFloat(sticker.getAttribute('data-animation-speed') || 20) / 100;
          this.animationSpeed = speed;
          
          if (animation === 'spin-scroll' || animation === 'float-scroll') {
            this.initScrollAnimation(sticker, animation);
          }
        });

        // Re-initialize on section reload
        document.addEventListener("shopify:section:load", (event) => {
          this.init();
        });
      }

      initScrollAnimation(sticker, animationType) {
        const image = sticker.querySelector('.td-sticker-image');
        
        window.addEventListener('scroll', () => {
          const {bottom, top} = sticker.getBoundingClientRect();
          
          if (top > 0 && (bottom - window.innerHeight) < 0) {
            if (animationType === 'spin-scroll') {
              image.style.rotate = (bottom * this.animationSpeed) + "deg";
              image.style.top = 0 + "px";
            }
            
            if (animationType === 'float-scroll') {
              image.style.rotate = 0 + "deg";
              image.style.top = (((sticker.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
            }
          }
        }, {
          passive: true,
          capture: false,
        });
      }
    }
    
    customElements.define('td-sticker-animated', TDStickerAnimated);
    
    // Initialize on page load
    document.addEventListener('DOMContentLoaded', () => {
      new TDStickerAnimated();
    });
    
    // Initialize when Shopify section loads
    document.addEventListener("shopify:section:load", (event) => {
      new TDStickerAnimated();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
